import { render, staticRenderFns } from "./MonitorIcon.vue?vue&type=template&id=4e5112d0"
import script from "./MonitorIcon.vue?vue&type=script&lang=ts"
export * from "./MonitorIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports